export default "__VITE_ASSET__C7N4_9f0__"